export const maskInput = (input: string) => input.replace(/[^A-ZÀ-ú0-9äÄöÖüÜß]/gi, '');
